import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { b2cDrivaApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${b2cDrivaApiUrl()}/api`;

export default createScopedApi(BASE_API_URL, axiosInstance);
